import { baseSocialeCkHelper, checkNormeRedazRegolam, getBaseSocialeControl, normeRedazRegolamHelper } from './helpers/base-sociale-form.helper';
import { isNilOrEmpty, toBoolean } from '@shared/helpers/utils.helper';
import { addRemoveError } from '@shared/helpers/form.helper';
import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { toNum } from '@shared/helpers/math.helper';
import { INCONGRUENT_NUMBER, INCONSISTENT_CHOICE, REQUIRED_STATUS } from '@shared/constants/shared.constants';

export const baseSocialeRapportiLavoroRules: FormGroupRules = {
    my_CkSocLavSub: (form: FormGroup) => {
        const my_CkSocLavSubControl = getBaseSocialeControl(form, 'my_CkSocLavSub');
        const my_CkSocLavSub: string = my_CkSocLavSubControl?.value;
        const my_CkSocLavParaSub: string = getBaseSocialeControl(form, 'my_CkSocLavParaSub')?.value;
        const my_CkSocLavSubTempoDeterminato: string = getBaseSocialeControl(form, 'my_CkSocLavSubTempoDeterminato')?.value;
        const my_CkSocLavAut: string = getBaseSocialeControl(form, 'my_CkSocLavAut')?.value;
        const my_CkCoopTraPro: string = getBaseSocialeControl(form, 'my_CkCoopTraPro')?.value;
        const my_CkContrattoCollLavSub: string = getBaseSocialeControl(form, 'my_CkContrattoCollLavSub')?.value;
        const my_CkRegolAvvNuove: string = getBaseSocialeControl(form, 'my_CkRegolAvvNuove')?.value;
        const my_NumSocLavSub: string = getBaseSocialeControl(form, 'my_NumSocLavSub')?.value;
        const my_NumSocLavSubTempoDeterminato: string = getBaseSocialeControl(form, 'my_NumSocLavSubTempoDeterminato')?.value;
        const my_NumSocLavParaSub: string = getBaseSocialeControl(form, 'my_NumSocLavParaSub')?.value;
        const my_NumSocLavAut: string = getBaseSocialeControl(form, 'my_NumSocLavAut')?.value;
        const my_UnitaSociUtil: string = getBaseSocialeControl(form, 'my_UnitaSociUtil')?.value;

        // Condizione 1 (all-zero + normeRedaz): key 'my_CkSocLavSub'
        almenoUnTipoDiContrattoHelper(form, 'my_CkSocLavSub');

        const errors = my_CkSocLavSubControl.errors ? my_CkSocLavSubControl.errors : {};

        // Condizione 2: CkSocLavSub=1, CoopTraPro=1, ContrattoCollLavSub=0
        const showContrattiError = my_CkSocLavSub === '1' && toNum(my_CkCoopTraPro) === 1 && toNum(my_CkContrattoCollLavSub) === 0;
        // Condizione 3: CkSocLavSub=1, CoopTraPro=1, RegolAvvNuove=0
        const showAvviamentoError = my_CkSocLavSub === '1' && toNum(my_CkCoopTraPro) === 1 && toNum(my_CkRegolAvvNuove) === 0;
        // Condizione 4: totale soci lavoratori ≠ UnitaSociUtil
        const showTotalError =
            checkNormeRedazRegolam(form) &&
            toNum(toBoolean(my_CkSocLavSubControl.value)) * toNum(my_NumSocLavSub) +
                toNum(toBoolean(my_CkSocLavSubTempoDeterminato)) * toNum(my_NumSocLavSubTempoDeterminato) +
                toNum(toBoolean(my_CkSocLavParaSub)) * toNum(my_NumSocLavParaSub) +
                toNum(toBoolean(my_CkSocLavAut)) * toNum(my_NumSocLavAut) !==
                toNum(my_UnitaSociUtil);

        addRemoveError(showContrattiError, errors, 'my_CkSocLavSub_contratti', {
            status: INCONSISTENT_CHOICE,
            message: 'Il regolamento non contiene il riferimento ai contratti collettivi.',
        });

        addRemoveError(showAvviamentoError, errors, 'my_CkSocLavSub_avviamento', {
            status: INCONSISTENT_CHOICE,
            message: 'il regolamento non contiene il riferimento al piano di avviamento.',
        });

        addRemoveError(showTotalError, errors, 'my_CkSocLavSub_total', {
            status: 'Errore nel totale soci lavoratori.',
            message: 'Il totale dei soci lavoratori è incoerente con quanto dichiarato nella forza lavoro.',
        });

        my_CkSocLavSubControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSocLavSubTempoDeterminato: (form: FormGroup) => {
        const my_CkSocLavSubTempoDeterminatoControl = getBaseSocialeControl(form, 'my_CkSocLavSubTempoDeterminato');
        const my_CkCoopTraPro = toNum(getBaseSocialeControl(form, 'my_CkCoopTraPro')?.value);
        const my_CkContrattoCollLavSub = toNum(getBaseSocialeControl(form, 'my_CkContrattoCollLavSub')?.value);
        const my_CkRegolAvvNuove = toNum(getBaseSocialeControl(form, 'my_CkRegolAvvNuove')?.value);

        // Condizione 5 (all-zero + normeRedaz): key 'my_CkSocLavSubTempoDeterminato'
        almenoUnTipoDiContrattoHelper(form, 'my_CkSocLavSubTempoDeterminato');

        const errors = my_CkSocLavSubTempoDeterminatoControl.errors ? my_CkSocLavSubTempoDeterminatoControl.errors : {};

        // Condizione 7: CkSocLavSubTempoDeterminato=1, CoopTraPro=1, ContrattoCollLavSub=0
        const showContrattiError = toNum(my_CkSocLavSubTempoDeterminatoControl?.value) === 1 && my_CkCoopTraPro === 1 && my_CkContrattoCollLavSub === 0;
        // Condizione 6: CkSocLavSubTempoDeterminato=1, CoopTraPro=1, RegolAvvNuove=0
        const showAvviamentoError = toNum(my_CkSocLavSubTempoDeterminatoControl?.value) === 1 && my_CkCoopTraPro === 1 && my_CkRegolAvvNuove === 0;

        addRemoveError(showContrattiError, errors, 'my_CkSocLavSubTempoDeterminato_contratti', {
            status: INCONSISTENT_CHOICE,
            message: 'Il regolamento non contiene il riferimento ai contratti collettivi.',
        });

        addRemoveError(showAvviamentoError, errors, 'my_CkSocLavSubTempoDeterminato_avviamento', {
            status: INCONSISTENT_CHOICE,
            message: 'Il regolamento non contiene il riferimento al piano di avviamento.',
        });

        my_CkSocLavSubTempoDeterminatoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSocLavParaSub: (form: FormGroup) => {
        const my_CkSocLavParaSubControl = getBaseSocialeControl(form, 'my_CkSocLavParaSub');
        const my_CkCoopTraPro = toNum(getBaseSocialeControl(form, 'my_CkCoopTraPro')?.value);
        const my_CkContrattoCollLavSub = toNum(getBaseSocialeControl(form, 'my_CkContrattoCollLavSub')?.value);
        const my_CkRegolAvvNuove = toNum(getBaseSocialeControl(form, 'my_CkRegolAvvNuove')?.value);

        // Condizione A (all-zero + normeRedaz): key 'my_CkSocLavParaSub'
        almenoUnTipoDiContrattoHelper(form, 'my_CkSocLavParaSub');

        const errors = my_CkSocLavParaSubControl.errors ? my_CkSocLavParaSubControl.errors : {};

        // Condizione C: CkSocLavParaSub=1, CoopTraPro=1, ContrattoCollLavSub=0
        const showContrattiError = toNum(my_CkSocLavParaSubControl?.value) === 1 && my_CkCoopTraPro === 1 && my_CkContrattoCollLavSub === 0;
        // Condizione B: CkSocLavParaSub=1, CoopTraPro=1, RegolAvvNuove=0
        const showAvviamentoError = toNum(my_CkSocLavParaSubControl?.value) === 1 && my_CkCoopTraPro === 1 && my_CkRegolAvvNuove === 0;

        addRemoveError(showContrattiError, errors, 'my_CkSocLavParaSub_contratti', {
            status: INCONSISTENT_CHOICE,
            message: 'Il regolamento non contiene il riferimento ai contratti collettivi.',
        });

        addRemoveError(showAvviamentoError, errors, 'my_CkSocLavParaSub_avviamento', {
            status: INCONSISTENT_CHOICE,
            message: 'Il regolamento non contiene il riferimento al piano di avviamento.',
        });

        my_CkSocLavParaSubControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSocLavAut: (form: FormGroup) => {
        almenoUnTipoDiContrattoHelper(form, 'my_CkSocLavAut');
        autonomiDueTerziHelper(form, 'my_CkSocLavAut');
    },

    my_CkSocLavAltro: (form: FormGroup) => {
        almenoUnTipoDiContrattoHelper(form, 'my_CkSocLavAltro');
    },

    my_NumSocLavSub: (form: FormGroup) => {
        ckNumArt1Helper(form, 'my_NumSocLavSub', 'my_CkSocLavSub');
    },

    my_NumSocLavSubTempoDeterminato: (form: FormGroup) => {
        ckNumArt1Helper(form, 'my_NumSocLavSubTempoDeterminato', 'my_CkSocLavSubTempoDeterminato');
    },

    my_NumSocLavParaSub: (form: FormGroup) => {
        ckNumArt1Helper(form, 'my_NumSocLavParaSub', 'my_CkSocLavParaSub');
    },

    my_NumSocLavAut: (form: FormGroup) => {
        autonomiDueTerziHelper(form, 'my_NumSocLavAut');
        ckNumArt1Helper(form, 'my_NumSocLavAut', 'my_CkSocLavAut');
    },

    my_NumSocLavAltro: (form: FormGroup) => {
        ckNumArt1Helper(form, 'my_NumSocLavAltro', 'my_CkSocLavAltro');
    },

    my_CkTipiRappLavConSociCorretti: (form: FormGroup) => {
        const my_CkTipiRappLavConSociCorrettiControl = getBaseSocialeControl(form, 'my_gruppo9.my_CkTipiRappLavConSociCorretti');
        const my_CkNormeSocioLavorat = toNum(getBaseSocialeControl(form, 'my_CkNormeSocioLavorat')?.value);
        const errors = my_CkTipiRappLavConSociCorrettiControl.errors ? my_CkTipiRappLavConSociCorrettiControl.errors : {};
        const showError = isNilOrEmpty(my_CkTipiRappLavConSociCorrettiControl?.value) && my_CkNormeSocioLavorat === 1;

        addRemoveError(showError, errors, 'my_CkTipiRappLavConSociCorretti', {
            status: REQUIRED_STATUS,
        });

        my_CkTipiRappLavConSociCorrettiControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkTipiRappLavCorretti: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkTipiRappLavCorretti', true, {
            status: REQUIRED_STATUS,
        });
    },

    my_MotTipiRappLavCorretti: (form: FormGroup) => {
        const my_MotTipiRappLavCorrettiControl = getBaseSocialeControl(form, 'my_MotTipiRappLavCorretti');
        const my_CkTipiRappLavCorretti: string = getBaseSocialeControl(form, 'my_CkTipiRappLavCorretti')?.value;
        const my_CkNormeSocioLavorat: string = getBaseSocialeControl(form, 'my_CkNormeSocioLavorat')?.value;
        const errors = my_MotTipiRappLavCorrettiControl.errors ? my_MotTipiRappLavCorrettiControl.errors : {};
        const showError = isNilOrEmpty(my_MotTipiRappLavCorrettiControl?.value) && my_CkTipiRappLavCorretti === '0' && my_CkNormeSocioLavorat === '1';

        addRemoveError(showError, errors, 'my_MotTipiRappLavCorretti', {
            status: REQUIRED_STATUS,
        });

        my_MotTipiRappLavCorrettiControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkContrApplicConforme: (form: FormGroup) => {
        baseSocialeCkHelper(form, 'my_gruppo11.my_CkContrApplicConforme', 'my_CkNormeSocioLavorat', 1);
    },

    my_DescContrSocLavNoConf: (form: FormGroup) => {
        baseSocialeCkHelper(form, 'my_DescContrSocLavNoConf', 'my_gruppo11.my_CkContrApplicConforme', 0);
    },
};

const TIPI_RAPPORTO_PATHS = ['my_CkSocLavSub', 'my_CkSocLavSubTempoDeterminato', 'my_CkSocLavParaSub', 'my_CkSocLavAut', 'my_CkSocLavAltro'];
const NUM_SOCI_LAVORATORI_PATHS = ['my_NumSocLavSub', 'my_NumSocLavSubTempoDeterminato', 'my_NumSocLavParaSub', 'my_NumSocLavAut', 'my_NumSocLavAltro'];

// InfoPath: error only when every checkbox is explicitly "0" (empty does not count as unchecked)
const almenoUnTipoDiContrattoHelper = (form: FormGroup, targetPath: string) => {
    const targetControl = getBaseSocialeControl(form, targetPath);
    const errors = targetControl.errors ? targetControl.errors : {};
    const showError = checkNormeRedazRegolam(form) && TIPI_RAPPORTO_PATHS.every((path) => toNum(getBaseSocialeControl(form, path)?.value) === 0);

    addRemoveError(showError, errors, targetPath, {
        status: 'Scegliere un tipo di rapporto.',
        message: 'Almeno un tipo di contratto deve essere selezionato.',
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

// InfoPath (on NumSocLavAut and CkSocLavAut): an empty NumSocLavAut never triggers the error (NaN comparison)
const autonomiDueTerziHelper = (form: FormGroup, targetPath: string) => {
    const targetControl = getBaseSocialeControl(form, targetPath);
    const my_NumSocLavAut = getBaseSocialeControl(form, 'my_NumSocLavAut')?.value;
    const totaleSociLavoratori = NUM_SOCI_LAVORATORI_PATHS.reduce((sum, path) => sum + (toNum(getBaseSocialeControl(form, path)?.value) ?? 0), 0);
    const errors = targetControl.errors ? targetControl.errors : {};
    const showError =
        !isNilOrEmpty(my_NumSocLavAut) && toNum(my_NumSocLavAut) < 0.66 * totaleSociLavoratori && toNum(getBaseSocialeControl(form, 'my_CkCoopTraPro')?.value) === 1;

    addRemoveError(showError, errors, `${targetPath}_professionisti`, {
        status: 'Cooperativa tra professionisti',
        message: 'In una cooperativa tra professionisti gli autonomi devono essere almeno 2/3 dei soci lavoratori',
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

const ckNumArt1Helper = (form: FormGroup, numberPath: string, ckPath: string) => {
    const numberControl = getBaseSocialeControl(form, numberPath);
    const ckValue = toNum(getBaseSocialeControl(form, ckPath)?.value);
    const errors = numberControl.errors ? numberControl.errors : {};
    const showError = checkNormeRedazRegolam(form) && ckValue === 1 && (isNilOrEmpty(numberControl?.value) || toNum(numberControl?.value) < 0);

    addRemoveError(showError, errors, numberPath, {
        status: INCONGRUENT_NUMBER,
    });

    numberControl.setErrors(isEqual(errors, {}) ? null : errors);
};
